import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var fastDryIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "m17.83 4.043 1.065 1.063.208.213c3.598 3.822 3.528 9.838-.208 13.575a9.75 9.75 0 0 1-13.79 0C1.47 15.26 1.306 9.468 4.613 5.638H3.129c-.5 0-1-.5-1-1v-.5h3.992c.558 0 1.01.453 1.01 1.01V9.14h-.502c-.5.003-1-.502-1-1.002l-.001-1.379a8.25 8.25 0 0 0 .539 11.076 8.25 8.25 0 0 0 11.667 0 8.25 8.25 0 0 0 0-11.668l-.356-.356a1 1 0 0 1 0-1.414l.352-.353ZM12 5.5a.75.75 0 0 1 .727.564c.373 1.453 1.143 2.468 1.823 3.363.746.982 1.45 1.91 1.45 3.156 0 2.307-1.645 3.917-4 3.917-1.088 0-2.085-.365-2.806-1.027C8.412 14.753 8 13.755 8 12.583c0-1.246.705-2.173 1.45-3.155.68-.896 1.45-1.911 1.823-3.364A.75.75 0 0 1 12 5.5Zm0 2.806c-.425.804-.922 1.458-1.355 2.028-.64.843-1.145 1.508-1.145 2.249 0 .742.245 1.359.709 1.785.444.408 1.08.632 1.791.632 1.153 0 2.5-.632 2.5-2.417 0-.741-.505-1.406-1.145-2.25-.433-.57-.93-1.223-1.355-2.027Z",
  fill: "currentColor"
}));

export { fastDryIcon as default };
//# sourceMappingURL=fastDryIcon.js.map
